
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getLocalizedTaxName } from '@/utils/getters';
import SelectComponent from '@/components/shared/Select.vue';

@Component<TaxRateSelect>({
	components: {
		SelectComponent
	}
})
export default class TaxRateSelect extends Vue {
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Prop({ type: Object, required: false, default: () => {} }) private itemTaxRates!: Taxes;
	@Prop({ type: String, required: false, default: '' }) private label!: string;
	@Prop({ type: Boolean, required: false, default: false }) private abbreviateSelection!: boolean;
	@Prop({ type: String, required: false, default: '' }) private id!: string;

	private get localizedPresetTaxRates(): PresetTaxes[] {
		return this.restaurant.preset_tax_rates.map((taxRate) => {
			const localizedName = getLocalizedTaxName(taxRate.name, this.restaurant);
			return {
				...taxRate,
				localizedName
			};
		});
	}

	/**
	 * Get selected tax rates
	 * We have to build the preset tax rates as an array of objects
	 *
	 * @return {PresetTaxes[]}
	 */
	private get selectedTaxRates(): PresetTaxes[] {
		if (!this.itemTaxRates) {
			return []; // Return an empty array if no tax rates are defined
		}
		return Object.keys(this.itemTaxRates).map((key) => {
			const rate = this.restaurant.preset_tax_rates.find((preset) => preset.name === key);
			if (rate) {
				return {
					...rate,
					localizedName: getLocalizedTaxName(rate.name, this.restaurant)
				};
			}
			return { name: key, value: this.itemTaxRates[key], is_default: false, localizedName: key };
		});
	}

	/**
	 * Handle tax rate selection change and reduce it to a key-value pair
	 *
	 * @param {PresetTaxes[]} selected
	 * @return {void}
	 */
	private handleTaxRateSelection(selected: PresetTaxes[]): void {
		const updatedTaxRates = selected.reduce((acc: Record<string, string>, tax) => {
			acc[tax.name] = tax.value;
			return acc;
		}, {});
		this.$emit('tax-rates-change', Object.keys(updatedTaxRates).length === 0 ? null : updatedTaxRates);
	}
}
